// Single source of truth for the app version shown in the UI.
// CRA injects any REACT_APP_* variable at build time; we fall back to a
// hard-coded constant so production builds with no env still work.
export const APP_VERSION =
  (typeof process !== "undefined" &&
    process.env &&
    process.env.REACT_APP_VERSION) ||
  "1.0.0";

// Expose to window so storage.js (which avoids importing from /lib for
// circular-safety) can stamp exports with the version.
if (typeof window !== "undefined") {
  window.__RSC_VERSION__ = APP_VERSION;
}
